export interface Address {

    nLocaID: number;
    sLocaFull: string;
    sLocaName: string;
    sLocaType: string;
    sAddr: string;
    sCity: string;
    sPost: string;
    sCtry: string;
    sCtryCode: string;
    sUnit: string;
    nNumber: number;
    fLat: any;
    fLong: any;
    sTimezone: string;
    jContact: any;
    sInstructions?: string;
}

export enum LocaType {
    AIR_PORT = 'AIR_PORT',
    HOME_ADDRESS = 'HOME_ADDRESS',
    HUB = 'HUB',
    OCEAN_PORT = 'OCEAN_PORT',
    PLANT = 'PLANT',
    RAIL_PORT = 'RAIL_PORT',
    SUPPLIER = 'SUPPLIER',
    WAREHOUSE = 'WAREHOUSE',
    WAITING_POINT = 'WAITING_POINT',
    FORWARDER_WAREHOUSE = 'FORWARDER_WAREHOUSE',
    CUSTOMS = 'CUSTOMS'
}
